import type { ReactNode } from 'react';
import BayTooltip from '../../BayTooltip';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const $: any;

type QuickActionType =
	| 'TEXTADMIN'
	| 'TEXTUSER'
	| 'MAIL'
	| 'NEWCONTACT'
	| 'CALL';

interface QuickActionItem {
	action: QuickActionType;
	icon?: ReactNode;
	toolTip?: string;
}

interface QuickActionsProps {
	isMenuLink: boolean;
	quickActionItem: QuickActionItem;
	index: number;
	publicId?: string;
	setShowContactModal: (show: boolean) => void;
	isContactBeta?: boolean;
}

const QuickActions = ({
	isMenuLink,
	quickActionItem,
	index,
	publicId,
	setShowContactModal,
	isContactBeta,
}: QuickActionsProps) => {
	const handleOnClick = (data: QuickActionType) => {
		switch (data) {
			case 'TEXTADMIN':
				/* eslint-disable-next-line no-undef */
				$.iqSMS_GetMessageDialog({
					action: 'Create',
					to: '',
					page: 'mail',
					contactid: publicId,
				});
				break;
			case 'TEXTUSER':
				/* eslint-disable-next-line no-undef */
				$.iqTextMessagingTabOpen();
				break;
			case 'MAIL':
				/* eslint-disable-next-line no-undef */
				$.iqMail_GetEmailDialog({
					action: 'Create',
					to: '',
					page: 'mail',
					contactid: publicId,
				});
				break;
			case 'NEWCONTACT':
				isContactBeta
					? setShowContactModal(true)
					: /* eslint-disable-next-line no-undef */
						$.iqContactManagement_MaintainContact(
							'Create',
							'',
							publicId,
							'Details',
							'0',
						);

				break;
			case 'CALL':
				/* eslint-disable-next-line no-undef */
				$.iqContactManagement_dialer('', '', '', isContactBeta);
				break;
			default:
				/* eslint-disable-next-line no-undef */
				$.iqContactManagement_MaintainContact(
					'Create',
					'',
					publicId,
					'Details',
					'0',
				);
				break;
		}
	};
	return (
		<>
			{isMenuLink ? (
				<a
					className="nav-link"
					role="button"
					onClick={() => handleOnClick(quickActionItem.action)}
				>
					{quickActionItem.toolTip}
				</a>
			) : (
				<>
					{index > 0 ? <div className="vertical-divider" /> : ''}
					<BayTooltip
						overlay={<span>{quickActionItem.toolTip || ''}</span>}
						placement="bottom"
					>
						<a
							className="quick-action-button d-flex justify-content-center align-items-center w-100"
							role="button"
							onClick={() => handleOnClick(quickActionItem.action)}
						>
							{quickActionItem.icon}
						</a>
					</BayTooltip>
				</>
			)}
		</>
	);
};

export default QuickActions;
